<template>
    <div
        class="content-wrapper wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: 100% !important; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section
            class="content-header"
            style="
                height: 40% !important;
                display: flex !important;
                position: sticky;
                justify-content: flex-end !important;
                flex-direction: column !important;
            "
        >
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 overflow-none">
                        <div class="row">
                            <div
                                class="white-box"
                                style="
                                    width: 100% !important;
                                    background-color: white !important;
                                    border-bottom-left-radius: 0px !important;
                                    border-bottom-right-radius: 0px !important;
                                    border-top-left-radius: 10px !important;
                                    border-top-right-radius: 10px !important;
                                    color: black !important;
                                    padding: 15px !important;
                                "
                            >
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-3">
                                            Document Date :
                                            <small>{{
                                                request_data.created_at
                                                    | timeStamp
                                            }}</small
                                            ><br />
                                            Place of Supply:
                                            <span
                                                class="right badge badge-secondary"
                                                >{{ placeofsupply }}</span
                                            >
                                        </div>
                                        <div class="col-md-3">
                                            <b>PO: {{ po_id }}</b>
                                        </div>
                                        <div class="col-md-3">
                                            <b>PR: {{ pr_id }}</b>
                                        </div>
                                        <div class="col-md-3">
                                            <b>GRPO: {{ grpo_id }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="grey-box"
                                style="
                                    width: 100% !important;
                                    background-color: lightslategrey !important;
                                    border-radius: 0px !important;
                                    color: white !important;
                                    padding: 15px !important;
                                "
                            >
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <b
                                                >Sub-Total :
                                                {{ total_taxable_amount }}</b
                                            >
                                        </div>
                                        <div class="col-md-3">
                                            <b>Total CGST: {{ total_cgst }}</b>
                                        </div>
                                        <div class="col-md-3">
                                            <b>Total SGST: {{ total_sgst }}</b>
                                        </div>
                                        <div class="col-md-3">
                                            <b>Total IGST: {{ total_igst }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="grey-box"
                                style="
                                    width: 100% !important;
                                    background-color: #383838 !important;
                                    border-radius: 0px !important;
                                    color: white !important;
                                    padding: 5px !important;
                                "
                            >
                                <div class="col-md-12">
                                    <div class="row justify-content-center">
                                        <div class="col-md-3">
                                            <h5>GRPO Quantity:</h5>
                                        </div>
                                        <div
                                            class="col-md-3"
                                            v-if="scan_mode == false"
                                        >
                                            <span
                                                class="right badge badge-success"
                                                ><h5>
                                                    {{ total_grpo_quantity }}
                                                </h5></span
                                            >
                                        </div>
                                        <div
                                            class="col-md-3"
                                            v-if="scan_mode == true"
                                        >
                                            <span
                                                class="right badge badge-secondary"
                                                ><h5>
                                                    Check Individual Saved
                                                    Counts
                                                </h5></span
                                            >
                                        </div>
                                        <div
                                            class="col-md-3"
                                            v-if="scan_mode == true"
                                        >
                                            <h5>Total PO Value:</h5>
                                        </div>
                                        <div
                                            class="col-md-3"
                                            v-if="scan_mode == true"
                                        >
                                            <span
                                                class="right badge badge-secondary"
                                                ><h5>
                                                    INR
                                                    {{
                                                        total_amount
                                                            | dotNumbers
                                                    }}
                                                </h5></span
                                            >
                                        </div>
                                        <div
                                            class="col-md-3"
                                            v-if="scan_mode == false"
                                        >
                                            <h5>Total GRPO Value:</h5>
                                        </div>
                                        <div
                                            class="col-md-3"
                                            v-if="scan_mode == false"
                                        >
                                            <span
                                                class="right badge badge-secondary"
                                                ><h5>
                                                    INR
                                                    {{
                                                        total_amount
                                                            | dotNumbers
                                                    }}
                                                </h5></span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div
                                class="white-box"
                                style="
                                    width: 100% !important;
                                    background-color: lightgrey !important;
                                    border-top-left-radius: 0px !important;
                                    border-top-right-radius: 0px !important;
                                    border-bottom-left-radius: 10px !important;
                                    border-bottom-right-radius: 10px !important;
                                    color: black !important;
                                    padding: 15px !important;
                                "
                            >
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div
                                                v-if="grpo_id != null"
                                                class="col-md-12"
                                            >
                                                <div
                                                    class="form-group"
                                                    v-if="
                                                        request_data.sap_doc_num ==
                                                        null
                                                    "
                                                >
                                                    <span
                                                        class="right badge badge-secondary"
                                                        >Upload Purchase
                                                        Invoice:*
                                                        <i
                                                            v-if="
                                                                purchase_invoice_image !=
                                                                ''
                                                            "
                                                            class="fa fa-check"
                                                            aria-hidden="true"
                                                        >
                                                            File selected</i
                                                        ></span
                                                    >
                                                    <input
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        type="file"
                                                        ref="file"
                                                        id="purchase_invoice_image"
                                                        name="purchase_invoice_image"
                                                        multiple
                                                        placeholder="Upload Purchase Invoice Image"
                                                        @change="
                                                            addPurchaseInvoiceImage
                                                        "
                                                    />
                                                </div>
                                                <table
                                                    v-if="
                                                        request_data.sap_doc_num !=
                                                        null
                                                    "
                                                    class="table thead-dark table-striped"
                                                    style="width: 100%"
                                                >
                                                    <colgroup>
                                                        <!--                                                        <col span="1" style="width: 25%" />-->
                                                        <col
                                                            span="1"
                                                            style="width: 100%"
                                                        />
                                                    </colgroup>
                                                    <tbody>
                                                        <tr>
                                                            <!--                                                        <td>Purchase Invoice:</td>-->
                                                            <td
                                                                style="
                                                                    border: none !important;
                                                                "
                                                            >
                                                                <p>
                                                                    <button
                                                                        style="
                                                                            width: 100% !important;
                                                                        "
                                                                        class="btn btn-success"
                                                                        @click="
                                                                            viewPurchaseInvoice()
                                                                        "
                                                                    >
                                                                        <i
                                                                            class="fa fa-search"
                                                                        ></i>
                                                                        View
                                                                        Purchase
                                                                        Invoice
                                                                        Image
                                                                    </button>
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-6"
                                            v-if="grpo_id == null"
                                        >
                                            <button
                                                class="btn btn-danger"
                                                style="width: 100% !important"
                                                @click="saveDraft"
                                            >
                                                Create new GRPO
                                                <i class="fa fa-plus"></i>
                                            </button>
                                        </div>
                                        <div
                                            class="col-md-6"
                                            v-if="
                                                grpo_id != null &&
                                                request_data.sap_doc_num == null
                                            "
                                        >
                                            <button
                                                class="btn"
                                                style="
                                                    width: 100% !important;
                                                    color: white !important;
                                                    background-color: #003334 !important;
                                                "
                                                @click="validateGRPOPrompt"
                                            >
                                                Validate GRPO
                                                <i
                                                    class="fa fa-arrow-right"
                                                ></i>
                                            </button>
                                        </div>
                                        <div
                                            class="col-md-6"
                                            v-if="
                                                grpo_id != null &&
                                                request_data.sap_doc_num != null
                                            "
                                        >
                                            <span
                                                class="right badge badge-warning"
                                                >SAP DOC NUM:
                                                {{
                                                    request_data.sap_doc_num
                                                }}</span
                                            ><br />
                                            <span
                                                class="right badge badge-warning"
                                                >SAP DOC ENTRY:
                                                {{
                                                    request_data.sap_doc_entry
                                                }}</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section
            class="content overflow-auto"
            style="height:40% !important; bottom: 0; !important;"
        >
            <!-- main row for all icons  -->
            <div class="col-md-12" style="height: 85% !important">
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-11">
                                <div class="row">
                                    <div class="col-md-12 ml-2">
                                        <div class="row">
                                            <div
                                                class="white-box"
                                                v-if="vendor != null"
                                                style="
                                                    width: 100% !important;
                                                    background-color: white !important;
                                                    border-radius: 10px !important;
                                                    color: black !important;
                                                    padding: 15px !important;
                                                "
                                            >
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <p>NAME:</p>
                                                                <h3>
                                                                    {{
                                                                        vendor.vendor_name
                                                                    }}
                                                                </h3>
                                                                <h5>
                                                                    {{
                                                                        vendor.vendor_code
                                                                    }}
                                                                </h5>
                                                            </div>
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <p>PHONE:</p>
                                                                <h5>
                                                                    {{
                                                                        vendor.primary_phone
                                                                    }}<br />
                                                                    {{
                                                                        vendor.alt_phone_1
                                                                    }}<br />
                                                                    {{
                                                                        vendor.alt_phone_2
                                                                    }}
                                                                </h5>
                                                                <p>EMAIL:</p>
                                                                <h5>
                                                                    {{
                                                                        vendor.primary_email
                                                                    }}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="row">
                                                                <div
                                                                    class="col-md-6"
                                                                >
                                                                    <div
                                                                        style="
                                                                            width: 100% !important;
                                                                        "
                                                                        :class="[
                                                                            'form-group',
                                                                            errors.billing_address
                                                                                ? 'has-error'
                                                                                : '',
                                                                        ]"
                                                                    >
                                                                        <label
                                                                            >Communication
                                                                            Address
                                                                            *</label
                                                                        >
                                                                        <p
                                                                            style="
                                                                                width: 100% !important;
                                                                            "
                                                                        >
                                                                            {{
                                                                                vendor.billing_address
                                                                            }},
                                                                            <br />
                                                                            {{
                                                                                vendor.billing_building
                                                                            }},
                                                                            <br />
                                                                            {{
                                                                                vendor.billing_street
                                                                            }},
                                                                            {{
                                                                                vendor.billing_street_no
                                                                            }},
                                                                            <br />
                                                                            {{
                                                                                vendor.billing_block
                                                                            }},
                                                                            <br />
                                                                            {{
                                                                                vendor.billing_city
                                                                            }},
                                                                            {{
                                                                                vendor.billing_zipcode
                                                                            }},
                                                                            {{
                                                                                vendor.billing_state
                                                                            }},
                                                                            {{
                                                                                vendor.billing_country
                                                                            }},
                                                                            <br />
                                                                            {{
                                                                                vendor.billing_tax_id
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div
                                                                    class="col-md-6"
                                                                >
                                                                    <div
                                                                        style="
                                                                            width: 100% !important;
                                                                        "
                                                                        :class="[
                                                                            'form-group',
                                                                            errors.comm_address
                                                                                ? 'has-error'
                                                                                : '',
                                                                        ]"
                                                                    >
                                                                        <label
                                                                            >Shipping
                                                                            Address
                                                                            *</label
                                                                        >
                                                                        <p
                                                                            style="
                                                                                width: 100% !important;
                                                                            "
                                                                        >
                                                                            {{
                                                                                vendor.shipping_address
                                                                            }},
                                                                            <br />
                                                                            {{
                                                                                vendor.shipping_building
                                                                            }},
                                                                            <br />
                                                                            {{
                                                                                vendor.shipping_street
                                                                            }},
                                                                            {{
                                                                                vendor.shipping_street_no
                                                                            }},
                                                                            <br />
                                                                            {{
                                                                                vendor.shipping_block
                                                                            }},
                                                                            <br />
                                                                            {{
                                                                                vendor.shipping_city
                                                                            }},
                                                                            {{
                                                                                vendor.shipping_zipcode
                                                                            }},
                                                                            {{
                                                                                vendor.shipping_state
                                                                            }},
                                                                            {{
                                                                                vendor.shipping_country
                                                                            }},
                                                                            <br />
                                                                            {{
                                                                                vendor.shipping_tax_id
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />

                        <div class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body overflow-auto">
                                        <div class="row">
                                            <table
                                                class="table thead-dark table-striped"
                                                style="width: 100%"
                                            >
                                                <colgroup>
                                                    <col
                                                        span="1"
                                                        style="width: 5%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 20%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 5%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 5%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 5%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 5%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 5%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 5%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 5%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 5%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 10%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 15%"
                                                    />
                                                    <col
                                                        span="1"
                                                        style="width: 10%"
                                                    />
                                                </colgroup>
                                                <thead class="thead-dark">
                                                    <th><b>Item Code</b></th>
                                                    <th><b>Item Details</b></th>
                                                    <th><b>Unit Price</b></th>
                                                    <th><b>Total Qty</b></th>
                                                    <th>
                                                        <b>Prior GRPO Qty</b>
                                                    </th>
                                                    <th><b>Ship To</b></th>
                                                    <th>
                                                        <b>Taxable Amount</b>
                                                    </th>
                                                    <th><b>CGST</b></th>
                                                    <th><b>SGST</b></th>
                                                    <th><b>IGST</b></th>
                                                    <th><b>Sub-Total</b></th>
                                                    <th
                                                        v-if="
                                                            draft_item.serial !=
                                                            ''
                                                        "
                                                    >
                                                        <b
                                                            >SERIAL/IMEI
                                                            Number</b
                                                        >
                                                    </th>
                                                    <th
                                                        v-if="
                                                            request_data.sap_doc_num !=
                                                            ''
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-cog"
                                                        ></i>
                                                    </th>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(
                                                            draft_item, index
                                                        ) in draft_items"
                                                    >
                                                        <td>
                                                            {{
                                                                draft_item.item_code
                                                            }}
                                                        </td>
                                                        <td>
                                                            <p>
                                                                {{
                                                                    draft_item.item_name
                                                                }}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            {{
                                                                draft_item.purchase_price
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                draft_item.order_quantity
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                draft_item.fulfilled_quantity
                                                            }}
                                                        </td>
                                                        <td>
                                                            <p>
                                                                {{
                                                                    draft_item.ship_to
                                                                }}
                                                            </p>
                                                            <!--                                                        <p>{{ draft_item.discount_amount }}</p>-->
                                                            <!--                                                        <p>({{ draft_item.discount_perc }}%)</p>-->
                                                        </td>
                                                        <td>
                                                            {{
                                                                draft_item.taxable_amount
                                                            }}
                                                        </td>
                                                        <td>
                                                            <p>
                                                                {{
                                                                    draft_item.cgst_amount
                                                                }}
                                                            </p>
                                                            <p>
                                                                ({{
                                                                    draft_item.cgst_perc
                                                                }}%)
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p>
                                                                {{
                                                                    draft_item.sgst_amount
                                                                }}
                                                            </p>
                                                            <p>
                                                                ({{
                                                                    draft_item.sgst_perc
                                                                }}%)
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p>
                                                                {{
                                                                    draft_item.igst_amount
                                                                }}
                                                            </p>
                                                            <p>
                                                                ({{
                                                                    draft_item.igst_perc
                                                                }}%)
                                                            </p>
                                                        </td>
                                                        <td>
                                                            {{
                                                                draft_item.bill_price
                                                            }}
                                                        </td>
                                                        <td
                                                            v-if="
                                                                grpo_id !=
                                                                    null &&
                                                                scan_mode !=
                                                                    true
                                                            "
                                                        >
                                                            <p>
                                                                {{
                                                                    draft_item.serial
                                                                }}
                                                            </p>
                                                        </td>
                                                        <td
                                                            v-if="
                                                                grpo_id !=
                                                                    null &&
                                                                scan_mode ==
                                                                    true
                                                            "
                                                        >
                                                            <p>~~~</p>
                                                        </td>
                                                        <td
                                                            v-if="
                                                                grpo_id == null
                                                            "
                                                        >
                                                            <p>~</p>
                                                        </td>
                                                        <td
                                                            v-if="
                                                                request_data.sap_doc_num !=
                                                                ''
                                                            "
                                                        >
                                                            <p
                                                                v-if="
                                                                    grpo_id !=
                                                                        null &&
                                                                    draft_item.fulfilled_quantity !=
                                                                        draft_item.order_quantity &&
                                                                    scan_mode ==
                                                                        true
                                                                "
                                                            >
                                                                <button
                                                                    style="
                                                                        width: 100% !important;
                                                                    "
                                                                    class="btn btn-warning"
                                                                    @click="
                                                                        scanItemsPrompt(
                                                                            draft_item
                                                                        )
                                                                    "
                                                                >
                                                                    <i
                                                                        class="fa fa-eye"
                                                                    ></i>
                                                                    Scan
                                                                </button>
                                                            </p>
                                                            <p
                                                                v-if="
                                                                    grpo_id !=
                                                                        null &&
                                                                    draft_item.fulfilled_quantity !=
                                                                        draft_item.order_quantity &&
                                                                    scan_mode ==
                                                                        true
                                                                "
                                                            >
                                                                <button
                                                                    style="
                                                                        width: 100% !important;
                                                                    "
                                                                    class="btn btn-danger"
                                                                    @click="
                                                                        generateSerialNumbersPrompt(
                                                                            draft_item
                                                                        )
                                                                    "
                                                                >
                                                                    <i
                                                                        class="fa fa-file"
                                                                    ></i>
                                                                    Generate
                                                                </button>
                                                            </p>
                                                            <p
                                                                v-if="
                                                                    grpo_id !=
                                                                        null &&
                                                                    scan_mode ==
                                                                        true
                                                                "
                                                            >
                                                                <button
                                                                    style="
                                                                        width: 100% !important;
                                                                    "
                                                                    class="btn btn-success"
                                                                    @click="
                                                                        showSavedItemsPrompt(
                                                                            draft_item
                                                                        )
                                                                    "
                                                                >
                                                                    <i
                                                                        class="fa fa-save"
                                                                    ></i>
                                                                    Saved
                                                                </button>
                                                            </p>
                                                            <p
                                                                v-if="
                                                                    grpo_id !=
                                                                        null &&
                                                                    draft_item.serial !=
                                                                        '' &&
                                                                    scan_mode ==
                                                                        false &&
                                                                    request_data.sap_doc_num ==
                                                                        null
                                                                "
                                                            >
                                                                <button
                                                                    style="
                                                                        width: 100% !important;
                                                                    "
                                                                    class="btn btn-danger"
                                                                    @click="
                                                                        deleteItemPrompt(
                                                                            draft_item
                                                                        )
                                                                    "
                                                                >
                                                                    <i
                                                                        class="fas fa-remove"
                                                                    ></i>
                                                                    Remove
                                                                </button>
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <div class="row">
                    <div v-if="grpo_id != null" class="col-md-12">
                        <div
                            class="form-group"
                            v-if="request_data.purchase_invoice_url == null"
                        >
                            <span class="right badge badge-secondary"
                                >Upload Purchase Invoice:
                                <i
                                    v-if="purchase_invoice_image != ''"
                                    class="fa fa-check"
                                    aria-hidden="true"
                                >
                                    File selected</i
                                ></span
                            >
                            <input
                                style="width: 100% !important"
                                type="file"
                                ref="file"
                                id="purchase_invoice_image"
                                name="purchase_invoice_image"
                                multiple
                                placeholder="Upload Purchase Invoice Image"
                                @change="addPurchaseInvoiceImage"
                            />
                        </div>
                        <table
                            v-if="grpo_data.purchase_invoice_url != null"
                            class="table thead-dark table-striped"
                            style="width: 100%"
                        >
                            <colgroup>
                                <col span="1" style="width: 25%" />
                                <col span="1" style="width: 75%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td>Purchase Invoice Image</td>
                                    <td>
                                        <p>
                                            <button
                                                style="width: 100% !important"
                                                class="btn btn-success"
                                                @click="viewPurchaseInvoice()"
                                            >
                                                <i class="fa fa-search"></i>
                                                View
                                            </button>
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br /><br /><br />
                    <br />
                    <br />
                    <br />
                    <div class="col-md-12">
                        <div class="row" align="center">
                            <div class="col-md-12">
                                <button
                                    v-if="grpo_id == null"
                                    class="btn btn-danger"
                                    style="width: 100% !important"
                                    @click="saveDraft"
                                >
                                    Create new GRPO <i class="fa fa-plus"></i>
                                </button>
                                <button
                                    v-if="
                                        grpo_id != null &&
                                        request_data.sap_doc_num == null
                                    "
                                    class="btn"
                                    style="
                                        width: 100% !important;
                                        color: white !important;
                                        background-color: #003334 !important;
                                    "
                                    @click="validateGRPOPrompt"
                                >
                                    Validate GRPO
                                    <i class="fa fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
                <br /><br /><br /><br />
            </div>

            <br />
            <br />

            <br />
            <br />

            <!-- row end -->
        </section>
        <!-- /.content -->

        <div class="modal" tabindex="-1" role="dialog" id="itemCodeModal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search Using Item Code</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the item code/sl. no."
                                            v-model="item_code"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-danger"
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    @click="
                                                        itemCodeSearch('code')
                                                    "
                                                >
                                                    Search By Item Code<span
                                                        class="right badge badge-success"
                                                        >{{
                                                            search_status
                                                        }}</span
                                                    >
                                                </button>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-danger"
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    @click="
                                                        itemCodeSearch('serial')
                                                    "
                                                >
                                                    Search By Serial Number<span
                                                        class="right badge badge-success"
                                                        >{{
                                                            search_status
                                                        }}</span
                                                    >
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="addDraftItemModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <h3>
                            Are you sure you want to add the item to this
                            purchase request? Have you verified the entries?
                        </h3>
                    </div>
                    <div class="modal-footer">
                        <button
                            class="btn btn-success"
                            @click="addDraftOrderItem"
                        >
                            Add to purchase request
                        </button>
                        <button class="btn btn-danger" data-dismiss="modal">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="addScannedItemModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <h3>
                            Are you sure you want to add the item to the scanned
                            items list? Have you verified the entries?
                        </h3>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="addScannedItem">
                            Add to scanned items
                        </button>
                        <button class="btn btn-danger" data-dismiss="modal">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="saveOrderConfirmModal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <h3>Are you sure you have verified the details?</h3>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="saveDraft">
                            Yes
                        </button>
                        <button class="btn btn-danger" data-dismiss="modal">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="deleteItemConfirmModal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <h3>Are you sure you want to delete this item?</h3>
                        <p>
                            {{ to_delete.serial }} of {{ to_delete.item_code }}
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="deleteGrpoItem">
                            Yes
                        </button>
                        <button class="btn btn-danger" data-dismiss="modal">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="saveGRPOConfirmModal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <h3>Are you sure you have verified the details?</h3>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="validateGRPO">
                            Yes
                        </button>
                        <button class="btn btn-danger" data-dismiss="modal">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="approveRequestConfirmModal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <h3>
                            Are you sure you have verified customer type and
                            invoice type?
                        </h3>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="makeDraft">
                            Yes
                        </button>
                        <button class="btn btn-danger" data-dismiss="modal">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            role="dialog"
            aria-labelledby="scanItemsModal"
            aria-hidden="true"
            id="scanItemsModal"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="icantthinkofaname">
                            Scan Items | Total Items scanned now:
                            <b>{{ total_scanned_items }}</b>
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="overflow-auto" style="height: 400px">
                            <div class="col-md-12">
                                <p>
                                    Now Scanning for: {{ draft_item.item_code }}
                                </p>
                                <h5>{{ draft_item.item_name }}</h5>
                                <table class="table table-striped table-hover">
                                    <thead
                                        class="thead-dark"
                                        style="position: sticky; top: 0"
                                    >
                                        <tr>
                                            <th class="header" scope="col">
                                                Item Code
                                            </th>
                                            <th class="header" scope="col">
                                                Scanned Serial Number
                                            </th>
                                            <th class="header" scope="col">
                                                Quantity
                                            </th>
                                            <th class="header" scope="col">
                                                Select
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(i, index) in scanned_items">
                                            <th scope="row">
                                                {{ i.item_code }}
                                            </th>
                                            <td>{{ i.serial }}</td>
                                            <td>{{ i.order_quantity }}</td>
                                            <td>
                                                <button
                                                    @click="
                                                        deleteScannedItem(index)
                                                    "
                                                    class="btn btn-danger"
                                                >
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-12">
                                <div class="card-footer">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-2">
                                                {{ draft_item.item_code }}
                                            </div>
                                            <div class="col-md-6">
                                                <input
                                                    type="text"
                                                    id="scannedSerial"
                                                    ref="scannedSerial"
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    class="form-control"
                                                    v-model="scanned_item"
                                                    placeholder="Enter Serial"
                                                    v-on:keyup.enter="
                                                        addScannedItem(
                                                            draft_item
                                                        )
                                                    "
                                                    autofocus
                                                    autofocus="autofocus"
                                                />
                                                <br />
                                                <input
                                                    type="text"
                                                    id="list_of_codes"
                                                    ref="list_of_codes"
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    class="form-control"
                                                    v-model="list_of_codes"
                                                    placeholder="Paste copied column (spaces exempted)"
                                                />
                                                <!--                                                    -->
                                            </div>
                                            <div class="col-md-1"></div>
                                            <div class="col-md-2" align="left">
                                                <button
                                                    class="btn btn-danger"
                                                    v-if="
                                                        draft_item.item_code !=
                                                        null
                                                    "
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    @click="
                                                        addScannedItem(
                                                            draft_item
                                                        )
                                                    "
                                                >
                                                    <i class="fa fa-plus"></i>
                                                    Add Item
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            @click="cleanScannedItemsArray"
                            class="btn btn-danger"
                        >
                            RESET
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            class="btn btn-success"
                            @click="saveItems"
                        >
                            Save to ERP
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            role="dialog"
            aria-labelledby="scanItemsModal"
            aria-hidden="true"
            id="generateItemSerialNumbersModal"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="icantthinkofaname">
                            Auto-Generate Serial Codes | Total generated:
                            <b>{{ total_scanned_items }}</b>
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="overflow-auto" style="height: 400px">
                            <p>Now Scanning for: {{ draft_item.item_code }}</p>
                            <h5>{{ draft_item.item_name }}</h5>
                            <div
                                v-if="scanned_items[0] == null"
                                class="col-md-12"
                            >
                                <div class="row">
                                    <div class="col-md-2">
                                        {{ draft_item.item_code }}
                                    </div>
                                    <div class="col-md-6">
                                        <input
                                            type="text"
                                            id="autogenerate_quantity"
                                            ref="autogenerate_quantity"
                                            style="width: 100% !important"
                                            class="form-control"
                                            v-model="autogenerate_quantity"
                                            placeholder="Enter Quantity"
                                            v-on:keyup.enter="
                                                saveGeneratedSerialNumbers(
                                                    draft_item
                                                )
                                            "
                                            autofocus
                                            autofocus="autofocus"
                                        />
                                        <!--                                                    -->
                                    </div>
                                    <div class="col-md-1"></div>
                                    <div class="col-md-2" align="left">
                                        <button
                                            class="btn btn-danger"
                                            v-if="draft_item.item_code != null"
                                            style="width: 100% !important"
                                            @click="
                                                saveGeneratedSerialNumbers(
                                                    draft_item
                                                )
                                            "
                                        >
                                            <i class="fa fa-save"></i> Generate
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="scanned_items[0] != null"
                                class="col-md-12"
                            >
                                <table class="table table-striped table-hover">
                                    <thead
                                        class="thead-dark"
                                        style="position: sticky; top: 0"
                                    >
                                        <tr>
                                            <th class="header" scope="col">
                                                Item Code
                                            </th>
                                            <th class="header" scope="col">
                                                Scanned Serial Number
                                            </th>
                                            <th class="header" scope="col">
                                                Quantity
                                            </th>
                                            <th class="header" scope="col">
                                                Select
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(i, index) in scanned_items">
                                            <th scope="row">
                                                {{ i.item_code }}
                                            </th>
                                            <td>{{ i.serial }}</td>
                                            <td>{{ i.order_quantity }}</td>
                                            <td>
                                                <button
                                                    @click="
                                                        deleteScannedItem(index)
                                                    "
                                                    class="btn btn-danger"
                                                >
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            @click="cleanScannedItemsArray"
                            class="btn btn-danger"
                        >
                            RESET
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            class="btn btn-success"
                            @click="saveItems"
                        >
                            Save to ERP
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            tabindex="-1"
            role="dialog"
            aria-labelledby="showSavedItemsModal"
            aria-hidden="true"
            id="showSavedItemsModal"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="icantthinkofaname">
                            Saved Items | Total Items saved now:
                            <b>{{ total_saved_items }}</b>
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="overflow-auto" style="height: 400px">
                            <table class="table table-striped table-hover">
                                <thead
                                    class="thead-dark"
                                    style="position: sticky; top: 0"
                                >
                                    <tr>
                                        <th class="header" scope="col">
                                            Item Code
                                        </th>
                                        <th class="header" scope="col">
                                            Saved Serial Number
                                        </th>
                                        <th class="header" scope="col">
                                            Quantity
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(i, index) in saved_items">
                                        <th scope="row">{{ i.item_code }}</th>
                                        <td>{{ i.serial }}</td>
                                        <td>{{ i.order_quantity }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            tabindex="-1"
            role="dialog"
            aria-labelledby="icantthinkofaname"
            aria-hidden="true"
            id="icantthinkofaname"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="icantthinkofaname">
                            Pick Item
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="overflow-auto" style="height: 400px">
                            <table class="table table-striped table-hover">
                                <thead
                                    class="thead-dark"
                                    style="position: sticky; top: 0"
                                >
                                    <tr>
                                        <th class="header" scope="col">
                                            Item Code
                                        </th>
                                        <th class="header" scope="col">
                                            Item Name
                                        </th>
                                        <th class="header" scope="col">
                                            TaxRate
                                        </th>
                                        <th class="header" scope="col">
                                            Serial
                                        </th>
                                        <th class="header" scope="col">
                                            Group Stock
                                        </th>
                                        <th class="header" scope="col">MOP</th>
                                        <th class="header" scope="col">MRP</th>
                                        <th class="header" scope="col">
                                            Select
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(i, index) in SAPItems">
                                        <th scope="row">{{ i.ItemCode }}</th>
                                        <th scope="row">{{ i.ItemName }}</th>
                                        <td>{{ i.TaxRate }}</td>
                                        <td>{{ i.SerialNumber }}</td>
                                        <td>{{ i.AvailableStock }}</td>
                                        <td>{{ i.MOP }}</td>
                                        <td>{{ i.MRP }}</td>
                                        <td>
                                            <button
                                                class="btn btn-primary"
                                                @click="selectItem(i)"
                                            >
                                                Select
                                            </button>
                                            <button
                                                class="btn btn-primary"
                                                @click="
                                                    requestDiscountPrompt(index)
                                                "
                                            >
                                                Discount
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                        <button type="button" class="btn btn-primary">
                            Save changes
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="searchitemsmodal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="searchitemsmodal"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="searchitemsmodal">
                            Pick Item
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="overflow-auto" style="height: 400px">
                            <table class="table table-striped table-hover">
                                <thead
                                    class="thead-dark"
                                    style="position: sticky; top: 0"
                                >
                                    <tr>
                                        <th class="header" scope="col">
                                            Item Code
                                        </th>
                                        <th class="header" scope="col">
                                            Item Name
                                        </th>
                                        <th class="header" scope="col">
                                            Warehouse/Stock
                                        </th>
                                        <th class="header" scope="col">
                                            Select
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="i in search_items">
                                        <td>{{ i.ItemCode }}</td>
                                        <th scope="row">
                                            {{ i.Brand }}
                                            <br />
                                            {{ i.ItemGroupName }}
                                            <br />
                                            {{ i.Product }}
                                            <br />
                                            {{ i.ItemName }} / {{ i.Colour }}
                                        </th>
                                        <td>{{ i.Stock }}</td>
                                        <td>
                                            <button
                                                class="btn btn-primary"
                                                @click="
                                                    SAPItemCodeSearch(
                                                        i.ItemCode
                                                    )
                                                "
                                            >
                                                Select
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="slModal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search Using Item Details</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <!--                                                linkedbranch list goes here later-->
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the item name"
                                                    v-model="params[0].itemname"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the product name"
                                                    v-model="
                                                        params[0].productname
                                                    "
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the brand"
                                                    v-model="params[0].brand"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the item classification type"
                                                    v-model="
                                                        params[0]
                                                            .itemclassificationtype
                                                    "
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the item classification value"
                                                    v-model="
                                                        params[0]
                                                            .itemclassificationvalue
                                                    "
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the camera"
                                                    v-model="params[0].camera"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the capacity"
                                                    v-model="params[0].capacity"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the colour"
                                                    v-model="params[0].colour"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the cpu"
                                                    v-model="params[0].cpu"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the goods/service type"
                                                    v-model="params[0].goods"
                                                    class="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the input/output/consumption"
                                                    v-model="
                                                        params[0].consumption
                                                    "
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the no. of kf"
                                                    v-model="params[0].noofkf"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the os"
                                                    v-model="params[0].os"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the processor"
                                                    v-model="
                                                        params[0].processor
                                                    "
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the RAM/Storage"
                                                    v-model="params[0].ram"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the rating"
                                                    v-model="params[0].rating"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the screen size"
                                                    v-model="
                                                        params[0].screensize
                                                    "
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the type/series"
                                                    v-model="params[0].type"
                                                    class="form-control"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    placeholder="Enter the resolution"
                                                    v-model="
                                                        params[0].resolution
                                                    "
                                                    class="form-control"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            @click="imeiSearch"
                                        >
                                            Search ERP for Item
                                            <span
                                                class="right badge badge-success"
                                                >{{ search_status }}</span
                                            >
                                        </button>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            id="b2bsearchmodal"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search B2B Customer</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the vendor code"
                                            v-model="vvendorcode"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the vendor name"
                                            v-model="vvendorname"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the phone number"
                                            v-model="vphone"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter GST number"
                                            v-model="vgstcode"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            @click="b2bSearch"
                                        >
                                            Search ERP for Vendor
                                            <span
                                                class="right badge badge-success"
                                                >{{ search_status }}</span
                                            >
                                        </button>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            id="b2bsearchmodal"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search B2B Customer</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="email"
                                            placeholder="Enter the email"
                                            v-model="b2bemail"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the phone"
                                            v-model="b2bphone"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the name"
                                            v-model="b2bname"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the card code"
                                            v-model="b2bcard"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the card gst no."
                                            v-model="b2bgst"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            @click="b2bSearch"
                                        >
                                            Search ERP for Vendors
                                            <span
                                                class="right badge badge-success"
                                                >{{ search_status }}</span
                                            >
                                        </button>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="POGeneratedModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div
                            class="col-md-12 justify-content-center"
                            align="center"
                        >
                            <div
                                class="row justify-content-center"
                                align="center"
                            >
                                <h3>
                                    PR has been approved and the following PO
                                    Numbers have been created:
                                </h3>
                                <br />
                            </div>
                            <div
                                class="row justify-content-center"
                                align="center"
                            >
                                <table
                                    class="table thead-dark table-striped"
                                    style="width: 100%"
                                >
                                    <colgroup>
                                        <col span="1" style="width: 100%" />
                                    </colgroup>
                                    <thead class="thead-dark">
                                        <th><b>PO Doc Nos.</b></th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(order, index) in orders">
                                            <td>{{ order.id }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-danger" @click="viewOrders">
                            View Orders
                        </button>
                        <button class="btn btn-danger" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" tabindex="-1" role="dialog" id="vendorsmodal">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <h3>Select Vendor</h3>
                        <table class="table table-striped table hover">
                            <thead>
                                <tr>
                                    <th scope="col">Customer Code</th>
                                    <th scope="col">Customer Name</th>
                                    <th scope="col">Customer Group Name</th>
                                    <th scope="col">Mobile Number</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Billing Address</th>
                                    <th scope="col">Shipping Address</th>
                                    <th scope="col">Choose</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="i in vendors">
                                    <td>{{ i.vendor_code }}</td>
                                    <td>{{ i.vendor_name }}</td>
                                    <td>{{ i.vendor_group_name }}</td>
                                    <td>{{ i.primary_phone }}</td>
                                    <td>{{ i.primary_email }}</td>
                                    <td>
                                        {{ i.billing_address }},
                                        {{ i.billing_building }},
                                        {{ i.billing_street }},
                                        {{ i.billing_street_no }},
                                        {{ i.billing_block }},
                                        {{ i.billing_city }},
                                        {{ i.billing_zipcode }},
                                        {{ i.billing_state }},
                                        {{ i.billing_country }},
                                        {{ i.billing_tax_id }}
                                    </td>
                                    <td>
                                        {{ i.shipping_address }},
                                        {{ i.shipping_building }},
                                        {{ i.shipping_street }},
                                        {{ i.shipping_street_no }},
                                        {{ i.shipping_block }},
                                        {{ i.shipping_city }},
                                        {{ i.shipping_zipcode }},
                                        {{ i.shipping_state }},
                                        {{ i.shipping_country }},
                                        {{ i.shipping_tax_id }}
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn-primary"
                                            @click="selectCustomer(i)"
                                        >
                                            Select
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            id="errormodal"
            role="dialog"
            tabindex="-1"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div
                        class="modal-header modal-danger"
                        style="background-color: red !important"
                    >
                        <h5 class="modal-title">Errors</h5>
                        <button
                            aria-label="Close"
                            class="close"
                            data-dismiss="modal"
                            type="button"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <span
                            v-if="errors.draftitems"
                            :class="['badge bg-danger']"
                            >Please enter atleast one valid item into draft
                            order</span
                        >
                        <pre>{{ returned_errors }}</pre>
                        <span
                            :class="['badge bg-secondary']"
                            v-if="returned_errors == null"
                            >{{ errors }}</span
                        >
                        <br v-if="errors.draftitems" />
                        <span
                            v-if="errors.customer"
                            :class="['badge bg-danger']"
                        >
                            Please enter a valid customer from our database or
                            create a new one
                            <span
                                v-if="errors.customer.billing_address"
                                :class="['badge bg-danger']"
                                >Please enter/select a valid billing address for
                                customer</span
                            >
                            <br v-if="errors.customer.billing_address" />
                            <span
                                v-if="errors.customer.shipping_address"
                                :class="['badge bg-danger']"
                                >Please enter/select a valid shipping address
                                for customer</span
                            >
                        </span>
                        <br v-if="errors.customer" />
                        <span
                            v-if="errors.deliverymode"
                            :class="['badge bg-danger']"
                            >Please enter a valid delivery mode
                            (default:branch)</span
                        ><br />
                        <span
                            v-if="errors.placeofsupply"
                            :class="['badge bg-danger']"
                            >Please enter a valid address for getting place of
                            supply</span
                        ><br />
                        <span v-if="errors.remarks" :class="['badge bg-danger']"
                            >Please enter a remark/note. It is mandatory</span
                        ><br />
                        <span
                            v-if="errors.purchase_invoice_image"
                            :class="['badge bg-danger']"
                            >Please upload the corresponding Purchase Invoice.
                            If its multiple images, try to consolidate into one.
                            It is mandatory</span
                        ><br />
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            id="b2bprimarymodal"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div
                        class="modal-header modal-danger"
                        style="background-color: red !important"
                    >
                        <h5 class="modal-title">Primary Details</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Customer ID</label>
                            <input
                                class="form-control"
                                v-model="b2bform.CustomerID"
                                placeholder="Enter the customer ID"
                                type="text"
                            />
                            <span
                                v-if="errors.CustomerID"
                                class="badge bg-danger"
                                >Please enter a valid customer ID</span
                            >
                        </div>
                        <div class="form-group">
                            <label>Customer Name</label>
                            <input
                                class="form-control"
                                v-model="b2bform.CustomerName"
                                placeholder="Enter the customer name"
                                type="text"
                            />
                            <span
                                v-if="errors.CustomerName"
                                class="badge bg-danger"
                                >Please enter a valid name</span
                            >
                        </div>
                        <div class="form-group">
                            <label>Phone 1</label>
                            <input
                                class="form-control"
                                v-model="b2bform.Phone1"
                                placeholder="Enter the phone 1"
                                type="text"
                            />
                            <span v-if="errors.Phone1" class="badge bg-danger"
                                >Please enter a valid phone number</span
                            >
                        </div>
                        <div class="form-group">
                            <label>Phone 2</label>
                            <input
                                class="form-control"
                                v-model="b2bform.Phone2"
                                placeholder="Enter the phone 2"
                                type="text"
                            />
                            <span v-if="errors.Phone2" class="badge bg-danger"
                                >Please enter a valid phone number</span
                            >
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input
                                class="form-control"
                                v-model="b2bform.Email"
                                placeholder="Enter the email"
                                type="email"
                            />
                            <span v-if="errors.Email" class="badge bg-danger"
                                >Please enter a valid email</span
                            >
                        </div>
                        <div class="form-group">
                            <label>PAN No.</label>
                            <input
                                class="form-control"
                                v-model="b2bform.PanNo"
                                placeholder="Enter the PAN no."
                                type="text"
                            />
                            <span v-if="errors.PanNo" class="badge bg-danger"
                                >Please enter a valid PAN no.</span
                            >
                        </div>
                        <div class="form-group">
                            <button
                                class="btn btn-primary"
                                @click="b2bNextStep"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            id="b2baddressmodal"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div
                        class="modal-header modal-danger"
                        style="background-color: red !important"
                    >
                        <h5 class="modal-title">Add Addresses</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Address Type</label>
                            <select
                                v-model="b2baddressform.AddressType"
                                class="form-control"
                            >
                                <option value="B">Billing</option>
                                <option value="S">Shipping</option>
                            </select>
                            <span
                                v-if="errors.AddressType"
                                class="badge bg-danger"
                                >Please enter a valid Address Type</span
                            >
                        </div>
                        <div class="form-group">
                            <label>Address Line 1</label>
                            <input
                                class="form-control"
                                v-model="b2baddressform.Address"
                                placeholder="Enter the address line 1"
                                type="text"
                            />
                            <span v-if="errors.Address" class="badge bg-danger"
                                >Please enter a valid line</span
                            >
                        </div>
                        <div class="form-group">
                            <label>Building</label>
                            <input
                                class="form-control"
                                v-model="b2baddressform.Building"
                                placeholder="Enter the Building"
                                type="text"
                            />
                            <span v-if="errors.Building" class="badge bg-danger"
                                >Please enter a valid Building</span
                            >
                        </div>
                        <div class="form-group">
                            <label>Street</label>
                            <input
                                class="form-control"
                                v-model="b2baddressform.Street"
                                placeholder="Enter the Street"
                                type="text"
                            />
                            <span v-if="errors.Street" class="badge bg-danger"
                                >Please enter a valid Street</span
                            >
                        </div>
                        <div class="form-group">
                            <label>StreetNo</label>
                            <input
                                class="form-control"
                                v-model="b2baddressform.StreetNo"
                                placeholder="Enter the StreetNo"
                                type="text"
                            />
                            <span v-if="errors.StreetNo" class="badge bg-danger"
                                >Please enter a valid StreetNo</span
                            >
                        </div>
                        <div class="form-group">
                            <label>Block</label>
                            <input
                                class="form-control"
                                v-model="b2baddressform.Block"
                                placeholder="Enter the Block"
                                type="text"
                            />
                            <span v-if="errors.Block" class="badge bg-danger"
                                >Please enter a valid Block</span
                            >
                        </div>
                        <div class="form-group">
                            <label>City</label>
                            <input
                                class="form-control"
                                v-model="b2baddressform.City"
                                placeholder="Enter the City"
                                type="text"
                            />
                            <span v-if="errors.City" class="badge bg-danger"
                                >Please enter a valid City</span
                            >
                        </div>
                        <div class="form-group">
                            <label>District</label>
                            <input
                                class="form-control"
                                v-model="b2baddressform.District"
                                placeholder="Enter the District"
                                type="text"
                            />
                            <span v-if="errors.District" class="badge bg-danger"
                                >Please enter a valid District</span
                            >
                        </div>
                        <div class="form-group">
                            <label>ZipCode</label>
                            <input
                                class="form-control"
                                v-model="b2baddressform.ZipCode"
                                placeholder="Enter the ZipCode"
                                type="number"
                                min="10000"
                            />
                            <span v-if="errors.ZipCode" class="badge bg-danger"
                                >Please enter a valid ZipCode</span
                            >
                        </div>
                        <div class="form-group">
                            <label>State</label>
                            <v-select
                                v-model="b2baddressform.State"
                                placeholder="Enter the Stae"
                                :options="states"
                                label="name"
                                :reduce="(states) => states.state_code"
                            ></v-select>
                            <span v-if="errors.State" class="badge bg-danger"
                                >Please enter a valid State</span
                            >
                        </div>
                        <div class="form-group">
                            <label>Country</label>
                            <input
                                class="form-control"
                                v-model="b2baddressform.Country"
                                placeholder="Enter the Country"
                                type="text"
                                value="IN"
                            />
                            <span v-if="errors.Country" class="badge bg-danger"
                                >Please enter a valid Country</span
                            >
                        </div>
                        <div class="form-group">
                            <label>GSTNo</label>
                            <input
                                class="form-control"
                                v-model="b2baddressform.GSTNo"
                                placeholder="Enter the GSTNo"
                                type="text"
                            />
                            <span v-if="errors.GSTNo" class="badge bg-danger"
                                >Please enter a valid GSTNo</span
                            >
                        </div>
                        <div class="form-group">
                            <button
                                class="btn btn-primary"
                                @click="b2bPushAddress"
                            >
                                Next
                            </button>
                        </div>
                        <div class="form-group" v-if="submitvendor == true">
                            <button
                                class="btn btn-primary"
                                @click="createb2bUser"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            id="purchaseinvoicemodal"
            role="dialog"
            tabindex="-1"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header modal-danger">
                        <h5 class="modal-title">
                            Purchase Invoice &nbsp; &nbsp;
                        </h5>
                        <button
                            class="btn btn-secondary"
                            @click="imageRotation"
                        >
                            Rotate
                            <i
                                class="fa fa-repeat"
                                aria-hidden="true"
                            ></i></button
                        ><button
                            aria-label="Close"
                            class="close"
                            data-dismiss="modal"
                            type="button"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body overflow-auto">
                        <img
                            class="transition"
                            v-bind:style="{ transform: `rotate(${deg}deg)` }"
                            style="
                                max-width: 100% !important;
                                height: auto !important;
                            "
                            :src="request_data.purchase_invoice_url"
                            alt="Purchase Invoice Image"
                        />
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <loading :show="lshow" :label="llabel"> </loading>
        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
            <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
import { parse } from "postcss";
import loading from "vue-full-loading";
import moment from "moment";

export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { loading },

    created() {
        // this.getBranches();
        this.backdoor++;
        // this.getWarehouses();

        // this.getAddons();
        // this.getStates();
        // this.getPurchaseAdmins();
        // this.getDeliveryModes();
        // this.getLinkedBranches();
        // this.getCreditLimit();
        if (
            typeof this.$route.params.purchase_order !== "undefined" &&
            typeof this.$route.params.grpo === "undefined"
        ) {
            this.po_id = this.$route.params.purchase_order;
            this.getPurchaseOrder();
        }
        if (typeof this.$route.params.grpo !== "undefined") {
            this.grpo_id = this.$route.params.grpo;
            this.getGRPO();
        }
    },

    data() {
        return {
            customertype: "b2b",
            pr_id: null,
            grpo_id: null,
            saved_data: [],
            collected_buffer: "",
            do_saved: 0,
            form: new Form({
                name: "",
                uid: "",
                gender: "",
                mobile: "",
                alt_mobile: "",
                phone: "",
                alt_phone: "",
                email: "",
                alt_email: "",
                dob: "",
                membership_id: "",
                category: "",
                area: "",
                id: "",
            }),
            heading: "",
            po_id: "",
            deg: 0,
            allow: false,
            aform: new Form({
                profile_id: "",
                addr_l1: "",
                addr_l2: "",
                addr_l3: "",
                city: "",
                state: "",
                pincode: "",
                id: "",
            }),
            customer: [],
            item_quantity: "1",

            itemform: new Form({
                item_code: "",
                item_type: "",
                item_name: "",
                sl: "",
                tax_rate: "",
                item_cgst_perc: "",
                item_sgst_perc: "",
                item_igst_perc: "",
                fulfilled_quantity: "",
                mop: "",
                purchase_price: "",
                item_mrp: "",
                itemlp: "",
                item_stock: "",
                item_available_stock: "",
                item_inward_date: "",
                item_branch: "",
                item_warehouse: "",
                discount_perc: "0",
                discount_amount: "",
                item_taxable_amount: "",
                item_cgst_amount: "",
                item_sgst_amount: "",
                item_igst_amount: "",
                item_total_tax: "",
                bill_price: "",
                hsn: "",
                brand: "",
                product: "",
                o2p: "",
                ext_warranty: "",
                care_pack: "",
            }),
            scan_mode: false,
            draft_item: [],
            to_delete: [],
            draft_items: [
                {
                    item_code: "",
                    item_name: "",
                    serial: "",
                    o2p: "",
                    ship_to: "",
                    care_pack: "",
                    ext_warranty: "",
                    item_cgst_perc: "",
                    item_sgst_perc: "",
                    mop: "",
                    purchase_price: "",
                    mrp: "",
                    order_quantity: "",
                    item_type: "",
                    item_branch: "",
                    discount_perc: "0",
                    discount_amount: "0",
                    taxable_amount: "",
                    cgst_amount: "",
                    sgst_amount: "",
                    igst_amount: "",
                    cgst_perc: "",
                    sgst_perc: "",
                    igst_perc: "",
                    bill_price: "",
                    fulfilled_quantity: "",
                    stock: "",
                    hsn: "",
                    brand: "",
                    product: "",
                    warehouse_code: "",
                    available_stock: "",
                    lp: "",
                    stock_purchase_date: "",
                },
            ],
            number: "",
            payment_items: [],
            buyback_items: [],
            billing_address: "",
            comm_address: "",
            addresses: [],
            status: "",
            apx_bill_no: "",
            campaign_media: "",
            job: [],
            addaddress: false,
            sl: "",
            remarks: "",
            item_code: "",
            branches: [],
            ship_to_branch: "",
            items: [],
            search_status: "",
            item: "",
            linked_branch: "",
            linked_branches: [],
            params: [
                {
                    productname: "",
                    brand: "",
                    itemname: "",
                    itemgroupname: "",
                    product: "",
                    itemcode: "",
                    itemclassificationtype: "",
                    itemclassificationvalue: "",
                    camera: "",
                    capacity: "",
                    category: "",
                    classification: "",
                    colour: "",
                    cpu: "",
                    goods: "",
                    consumption: "",
                    noofkf: "",
                    os: "",
                    processor: "",
                    ram: "",
                    rating: "",
                    screensize: "",
                    type: "",
                    resolution: "",
                },
            ],
            payment_mode: "",
            finance_mode: "",
            purchase_admin: "",
            payment_details: [],
            search_items: [],
            purchase_admins: [],
            SAPItems: [],
            pms: [],
            fms: [],
            warehouses: [],
            b2bemail: "",
            b2bphone: "",
            b2bname: "",
            b2bcard: "",
            approved_by: "",
            b2bgst: "",
            vendors: [],
            vendor: null,
            deliverymode: "",
            delivery_requested_on: "",
            salesmen: [],
            buyback_slabs: [],
            addons: [],
            lshow: false,
            llabel: "",
            account_code: "",
            states: [],
            cities: [],
            state_id: "",
            city_id: "",
            erp_ref: "",
            placeofsupply: "32",
            errors: [],
            scanned_items: [],
            list_of_codes: "",
            codes_buffer: [],
            scanned_item: "",
            saved_items: [],
            saved_item: "",
            generated_serials: [],
            b2bform: new Form({
                CustomerID: "",
                CustomerName: "",
                Phone1: "",
                Phone2: "",
                Email: "",
                PanNo: "",
            }),
            request_data: [],

            b2baddressform: {
                AddressType: "",
                Address: "",
                Building: "",
                Street: "",
                StreetNo: "",
                Block: "",
                City: "",
                District: "",
                ZipCode: "",
                State: "",
                Country: "",
                GSTNo: "",
            },
            medias: [],
            slabs: [],
            serial: "",
            newb2bAddresses: [],
            submitvendor: false,
            delivery_modes: [],
            approved_purchase_request: [],
            orders: [],
            purchase_request: {},
            draftorderid: "",
            receipts: [],
            backdoor: 0,
            files: [],
            buybackimages: [],
            gpstatuses: [],
            purchase_request_status: "",
            reasons: [],
            turnaway_reason: "",
            discountindex: "",
            discount_requests: [],
            requested_amount: "",
            branchlock: {},
            credit_limit: [],
            requested_credit: "",
            requested_credit_notes: "",
            gifts: [],
            givegiftnotes: "",
            allotment_id: "",
            title: "",
            mastervendors: [],
            tcs: [],
            tresults: "",
            tbranch: "",
            tcategory: "",
            tsearchname: "",
            vbranchcode: "",
            vvendorcode: "",
            vvendorname: "",
            vphone: "",
            vgstcode: "",
            grpo_data: [],
            returned_errors: [],
            purchase_invoice_image: "",
            autogenerate_quantity: "",
            autogen_tag: "0",
            sap_no: "",
        };
    },

    computed: {
        item_taxable_amount: function () {
            // cache: false;
            this.backdoor;
            let base =
                parseFloat(
                    this.itemform.purchase_price - this.itemform.discount_amount
                ) * parseFloat(this.item_quantity);
            let cgst =
                base *
                (this.itemform.item_cgst_perc /
                    (parseFloat(this.itemform.item_sgst_perc) +
                        parseFloat(this.itemform.item_cgst_perc) +
                        100));
            let sgst =
                base *
                (this.itemform.item_sgst_perc /
                    (parseFloat(this.itemform.item_sgst_perc) +
                        parseFloat(this.itemform.item_cgst_perc) +
                        100));
            let igst =
                base *
                (this.itemform.item_igst_perc /
                    (parseFloat(this.itemform.item_igst_perc) +
                        parseFloat(this.itemform.item_igst_perc) +
                        100));

            let calculatedTotal =
                (parseFloat(base) * 100) /
                (parseFloat(this.itemform.item_sgst_perc) +
                    parseFloat(this.itemform.item_cgst_perc) +
                    parseFloat(this.itemform.item_igst_perc) +
                    100);
            this.itemform.item_taxable_amount = calculatedTotal;
            this.itemform.item_taxable_amount =
                this.itemform.item_taxable_amount.toFixed(2);

            return this.itemform.item_taxable_amount;
        },
        bill_price: function () {
            // cache: false;
            this.backdoor;
            let calculatedTotal =
                parseFloat(this.itemform.item_taxable_amount) +
                parseFloat(this.itemform.item_total_tax);
            this.itemform.bill_price = calculatedTotal;
            this.itemform.bill_price = this.itemform.bill_price.toFixed(2);
            //   this.itemform.bill_price = Math.round(this.itemform.bill_price);

            return this.itemform.bill_price;
        },
        item_cgst_amount: function () {
            // cache: false;
            this.backdoor;
            let base =
                parseFloat(
                    this.itemform.purchase_price - this.itemform.discount_amount
                ) * parseFloat(this.item_quantity);
            let calculatedTotal =
                base *
                (this.itemform.item_cgst_perc /
                    (parseFloat(this.itemform.item_sgst_perc) +
                        parseFloat(this.itemform.item_cgst_perc) +
                        100));
            this.itemform.item_cgst_amount = calculatedTotal;
            this.itemform.item_cgst_amount =
                this.itemform.item_cgst_amount.toFixed(2);

            return this.itemform.item_cgst_amount;
        },
        item_igst_amount: function () {
            // cache: false;
            this.backdoor;
            let base =
                parseFloat(
                    this.itemform.purchase_price - this.itemform.discount_amount
                ) * parseFloat(this.item_quantity);
            let calculatedTotal =
                base *
                (this.itemform.item_igst_perc /
                    (parseFloat(this.itemform.item_igst_perc) +
                        parseFloat(this.itemform.item_cgst_perc) +
                        parseFloat(this.itemform.item_sgst_perc) +
                        100));
            this.itemform.item_igst_amount = calculatedTotal;
            this.itemform.item_igst_amount =
                this.itemform.item_igst_amount.toFixed(2);

            return this.itemform.item_igst_amount;
        },
        item_sgst_amount: function () {
            // cache: false;
            this.backdoor;
            let base =
                parseFloat(
                    this.itemform.purchase_price - this.itemform.discount_amount
                ) * parseFloat(this.item_quantity);
            let calculatedTotal =
                base *
                (this.itemform.item_sgst_perc /
                    (parseFloat(this.itemform.item_sgst_perc) +
                        parseFloat(this.itemform.item_cgst_perc) +
                        100));
            this.itemform.item_sgst_amount = calculatedTotal;
            this.itemform.item_sgst_amount =
                this.itemform.item_sgst_amount.toFixed(2);

            return this.itemform.item_sgst_amount;
        },
        item_total_tax: function () {
            // cache: false;
            this.backdoor;
            let calculatedTotal =
                parseFloat(this.itemform.item_cgst_amount) +
                parseFloat(this.itemform.item_sgst_amount) +
                parseFloat(this.itemform.item_igst_amount);
            this.itemform.item_total_tax = calculatedTotal;

            return this.itemform.item_total_tax;
        },
        total_taxable_amount() {
            cache: false;
            return this.draft_items.reduce((total_taxable_amount, item) => {
                let total_base =
                    parseFloat(total_taxable_amount) +
                    parseFloat(item.taxable_amount);
                total_base = total_base.toFixed(2);
                return total_base;
            }, 0);
        },
        total_scanned_items() {
            cache: false;
            return this.scanned_items.reduce(
                (count, value) => (value != "" ? count + 1 : count),
                0
            );
        },
        total_grpo_quantity() {
            cache: false;
            return this.draft_items.reduce(
                (count, value) => (value != "" ? count + 1 : count),
                0
            );
        },
        total_saved_items() {
            cache: false;
            return this.saved_items.reduce(
                (count, value) => (value != "" ? count + 1 : count),
                0
            );
        },
        total_cgst() {
            cache: false;
            return this.draft_items.reduce((total_cgst, item) => {
                let total_cgst_amount =
                    parseFloat(total_cgst) + parseFloat(item.cgst_amount);
                total_cgst_amount = total_cgst_amount.toFixed(2);
                return total_cgst_amount;
            }, 0);
        },
        total_sgst() {
            cache: false;
            return this.draft_items.reduce((total_sgst, item) => {
                let total_sgst_amount =
                    parseFloat(total_sgst) + parseFloat(item.sgst_amount);
                total_sgst_amount = total_sgst_amount.toFixed(2);
                return total_sgst_amount;
            }, 0);
        },
        total_igst() {
            cache: false;
            return this.draft_items.reduce((total_igst, item) => {
                let total_igst_amount =
                    parseFloat(total_igst) + parseFloat(item.igst_amount);
                total_igst_amount = total_igst_amount.toFixed(2);
                return total_igst_amount;
            }, 0);
        },
        buyback_total_amount() {
            cache: false;
            return this.buyback_items.reduce((buyback_total, item) => {
                let round_buyback_total =
                    parseFloat(buyback_total) + parseFloat(item.taken_for);
                round_buyback_total = Math.round(round_buyback_total);
                return round_buyback_total;
            }, 0);
        },

        total_amount() {
            cache: false;
            return this.draft_items.reduce((total_amount, item) => {
                let round_total =
                    parseFloat(total_amount) + parseFloat(item.bill_price);
                // round_total = Math.round(round_total);
                return round_total;
            }, 0);
        },
        total_discount_amount() {
            cache: false;
            return this.draft_items.reduce((total_discount_amount, item) => {
                let round_total =
                    parseFloat(total_discount_amount) +
                    parseFloat(item.discount_amount);
                // round_total = Math.round(round_total);
                return round_total;
            }, 0);
        },
        total_discount_perc() {
            cache: false;
            return this.draft_items.reduce((total_discount_perc, item) => {
                let round_total =
                    parseFloat(total_discount_perc) +
                    parseFloat(item.discount_perc);
                // round_total = Math.round(round_total);
                return round_total;
            }, 0);
        },
        payment_status() {
            cache: false;
            this.backdoor;
            let payment_buffer = "";
            this.collected_buffer =
                parseFloat(this.collected_payments_total) +
                parseFloat(this.buyback_total_amount);
            if (
                parseFloat(this.total_amount) != 0 &&
                parseFloat(this.collected_buffer) >=
                    parseFloat(this.total_amount)
            )
                payment_buffer = "Complete";
            else payment_buffer = "Pending";
            return payment_buffer;
        },
    },
    //   COMPUTED ENDS

    watch: {
        value() {
            this.backdoor++;
        },
    },

    //https://logaretm.com/blog/forcing-recomputation-of-computed-properties/

    methods: {
        getGRPO() {
            // if (typeof this.$route.params.purchase_order !== "undefined") {
            if (this.grpo_id != "") {
                axios
                    .post("/api/getGRPO", { id: this.grpo_id })
                    .then((response) => {
                        // Write code here
                        this.request_data = response.data.order;
                        this.grpo_data = response.data.order;
                        axios
                            .post("/api/getSAPVendors", {
                                branch_code: this.vbranchcode,
                                vendor_code: this.request_data.customer_id,
                                vendor_name: this.vvendorname,
                                phone: this.vphone,
                            })
                            .then((response) => {
                                this.vendor = response.data[0];
                                this.vendor.billing_address =
                                    this.request_data.bill_address;
                                this.vendor.billing_building =
                                    this.request_data.bill_building;
                                this.vendor.billing_street =
                                    this.request_data.bill_street;
                                this.vendor.billing_street_no =
                                    this.request_data.bill_street_no;
                                this.vendor.billing_block =
                                    this.request_data.bill_block;
                                this.vendor.billing_city =
                                    this.request_data.bill_city;
                                this.vendor.billing_zipcode =
                                    this.request_data.bill_zip_code;
                                this.vendor.billing_state =
                                    this.request_data.bill_state;
                                this.vendor.billing_country =
                                    this.request_data.bill_country;
                                this.vendor.billing_tax_id =
                                    this.request_data.gst_regn_no;
                                this.vendor.shipping_address =
                                    this.request_data.ship_address;
                                this.vendor.shipping_building =
                                    this.request_data.ship_building;
                                this.vendor.shipping_street =
                                    this.request_data.ship_street;
                                this.vendor.shipping_street_no =
                                    this.request_data.ship_street_no;
                                this.vendor.shipping_block =
                                    this.request_data.ship_block;
                                this.vendor.shipping_city =
                                    this.request_data.ship_city;
                                this.vendor.shipping_zipcode =
                                    this.request_data.ship_zip_code;
                                this.vendor.shipping_state =
                                    this.request_data.ship_state;
                                this.vendor.shipping_country =
                                    this.request_data.ship_country;
                                this.vendor.shipping_tax_id =
                                    this.request_data.gst_regn_no;
                                $("#b2bsearchmodal").modal("hide");
                            });
                        this.sap_no = this.request_data.sap_doc_no;
                        // this.purchase_invoice_image=this.request_data.purchase_invoice_url;
                        this.po_id = this.request_data.purchase_order_id;
                        this.pr_id = this.request_data.purchase_request_id;
                        this.draft_items = response.data.items;
                        this.remarks = this.request_data.remarks;
                        this.purchase_admin =
                            this.request_data.to_be_approved_by;
                        this.approved_by = this.request_data.approved_by;
                        this.branch = this.request_data.branch_code;
                        this.placeofsupply = this.request_data.place_of_supply;
                    });
            }
            console.log(this.grpo_id);
        },

        getPurchaseOrder() {
            // if (typeof this.$route.params.purchase_order !== "undefined") {
            if (this.po_id != "") {
                axios
                    .post("/api/getPurchaseOrder", { id: this.po_id })
                    .then((response) => {
                        // Write code here
                        this.request_data = response.data.order;
                        axios
                            .post("/api/getSAPVendors", {
                                branch_code: this.vbranchcode,
                                vendor_code: this.request_data.customer_id,
                                vendor_name: this.vvendorname,
                                phone: this.vphone,
                            })
                            .then((response) => {
                                this.vendor = response.data[0];
                                this.vendor.billing_address =
                                    this.request_data.bill_address;
                                this.vendor.billing_building =
                                    this.request_data.bill_building;
                                this.vendor.billing_street =
                                    this.request_data.bill_street;
                                this.vendor.billing_street_no =
                                    this.request_data.bill_street_no;
                                this.vendor.billing_block =
                                    this.request_data.bill_block;
                                this.vendor.billing_city =
                                    this.request_data.bill_city;
                                this.vendor.billing_zipcode =
                                    this.request_data.bill_zip_code;
                                this.vendor.billing_state =
                                    this.request_data.bill_state;
                                this.vendor.billing_country =
                                    this.request_data.bill_country;
                                this.vendor.billing_tax_id =
                                    this.request_data.gst_regn_no;
                                this.vendor.shipping_address =
                                    this.request_data.ship_address;
                                this.vendor.shipping_building =
                                    this.request_data.ship_building;
                                this.vendor.shipping_street =
                                    this.request_data.ship_street;
                                this.vendor.shipping_street_no =
                                    this.request_data.ship_street_no;
                                this.vendor.shipping_block =
                                    this.request_data.ship_block;
                                this.vendor.shipping_city =
                                    this.request_data.ship_city;
                                this.vendor.shipping_zipcode =
                                    this.request_data.ship_zip_code;
                                this.vendor.shipping_state =
                                    this.request_data.ship_state;
                                this.vendor.shipping_country =
                                    this.request_data.ship_country;
                                this.vendor.shipping_tax_id =
                                    this.request_data.gst_regn_no;
                                $("#b2bsearchmodal").modal("hide");
                            });
                        this.draft_items = response.data.items;
                        this.remarks = this.request_data.remarks;
                        this.purchase_admin =
                            this.request_data.to_be_approved_by;
                        this.approved_by = this.request_data.approved_by;
                        this.branch = this.request_data.branch_code;
                        this.pr_id = this.request_data.purchase_request_id;
                        this.request_data.sap_doc_num = null;
                        this.scan_mode = true;
                        this.placeofsupply = this.request_data.place_of_supply;
                    });
            }
            console.log(this.po_id);
        },

        addPurchaseInvoiceImage(event) {
            this.purchase_invoice_image = event.target.files[0];
            console.log(this.purchase_invoice_image);
            // this.url = URL.createObjectURL(this.gatepass_image);
        },

        getLinkedBranches() {
            axios.post("/api/getAllowedBranches\n").then((response) => {
                this.linked_branches = response.data.data;
            });
        },

        getBranches() {
            axios.post("/api/getSAPBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getDeliveryModes() {
            axios.post("/api/getDeliveryModes").then((response) => {
                this.delivery_modes = response.data;
            });
        },

        getSavedItems() {
            if (this.grpo_id != "") {
                axios
                    .post("/api/getSavedGRPOItems", {
                        grpo_id: this.grpo_id,
                        item_code: this.item_id,
                    })
                    .then((response) => {
                        // Write code here
                        this.saved_items = response.data;
                    });
            }
            console.log(this.po_id);
        },

        scanItemsPrompt(item) {
            this.draft_item = item;
            console.log(this.item_id);
            // this.allotment_id = allotment.id;
            // this.title = "A "+allotment.gift_rule.assigned_gift+" is given to "+allotment.gift_registration.first_name+" "+allotment.gift_registration.last_name+", "+allotment.phone;
            $("#scanItemsModal").modal("show");
            this.focusInput();
        },

        deleteItemPrompt(item) {
            this.to_delete = item;
            console.log(this.to_delete);
            // this.allotment_id = allotment.id;
            // this.title = "A "+allotment.gift_rule.assigned_gift+" is given to "+allotment.gift_registration.first_name+" "+allotment.gift_registration.last_name+", "+allotment.phone;
            $("#deleteItemConfirmModal").modal("show");
        },

        deleteGrpoItem() {
            console.log(this.to_delete);
            this.llabel = "Deleting...";
            this.lshow = true;
            axios
                .post("/api/deleteGrpoItem", { item: this.to_delete })
                .then((response) => {
                    if (response.data == true) {
                        toast.fire({
                            icon: "success",
                            title: "Deleted",
                        });
                        this.llabel = "Deleted!";
                        this.lshow = false;
                        this.getGRPO();
                        $("#deleteItemConfirmModal").modal("hide");
                    } else
                        toast.fire({
                            icon: "error",
                            title: "Failed to delete",
                        });
                    console.log(response.data);
                    this.llabel = "Not Deleted";
                    $("#deleteItemConfirmModal").modal("hide");
                    this.lshow = false;
                })
                .catch((error) => {
                    toast.fire({
                        icon: "error",
                        title: "Deletion Failed",
                    });
                    this.llabel = "Deletion Failed!";
                    this.lshow = false;
                    $("#deleteItemConfirmModal").modal("hide");
                    this.getGRPO();
                });
        },

        generateSerialNumbersPrompt(item) {
            this.draft_item = item;
            console.log(this.item_id);
            $("#generateItemSerialNumbersModal").modal("show");
        },

        showSavedItemsPrompt(item) {
            this.item_id = item.item_code;
            console.log(this.item_id);
            this.getSavedItems();
            // this.allotment_id = allotment.id;
            // this.title = "A "+allotment.gift_rule.assigned_gift+" is given to "+allotment.gift_registration.first_name+" "+allotment.gift_registration.last_name+", "+allotment.phone;
            $("#showSavedItemsModal").modal("show");
        },

        getAddons() {
            axios.post("/api/getServices").then((response) => {
                this.addons = response.data;
            });
        },

        getStates() {
            axios.post("/api/getStates", { country: 101 }).then((response) => {
                this.states = response.data;
            });
        },

        getCities() {
            axios
                .post("/api/getCities", { state: this.state_id })
                .then((response) => {
                    this.cities = response.data;
                });
        },

        stateChange() {
            var state = this.states.find((s) => s.id == this.state_id);
            this.aform.state = state.state_code;
            this.getCities();
        },

        getStatePrefix() {
            var state = this.vendor.shipping_state;
            axios
                .post("/api/getStatePrefix", { state: state })
                .then((response) => {
                    this.placeofsupply = response.data;
                });
        },

        cityChange() {
            var city = this.cities.find((s) => s.id == this.city_id);
            this.aform.city = city.name;
        },

        getWarehouses() {
            axios.post("/api/getWarehouses").then((response) => {
                this.warehouses = response.data;
            });
        },

        updateDiscountAmount() {
            if (this.itemform.discount_amount != 0) {
                this.itemform.discount_perc =
                    (this.itemform.discount_amount /
                        this.itemform.purchase_price) *
                    100;
                this.itemform.discount_perc =
                    this.itemform.discount_perc.toFixed(2);
            } else {
                this.itemform.discount_perc = 0;
            }
        },

        viewOrders() {
            this.lshow = false;
            $("#POGeneratedModal").modal("hide");
            this.lshow = false;
            this.$router.push("/purchase-orders");
        },

        getOrder() {
            axios
                .post("/api/getPurchaseOrder", { id: this.$route.params.po_id })
                .then((response) => {
                    this.order = response.data.order;
                    this.company = response.data.company;
                    this.ship_to = response.data.ship_to;
                    this.items = response.data.items;
                    this.branch = response.data.branch;
                    this.value;
                });
        },

        itemCodeModal() {
            this.search_status = "";
            $("#itemCodeModal").modal("show");
        },

        slModal() {
            this.search_status = "";
            $("#slModal").modal("show");
        },

        addDraftItemPrompt() {
            $("#addDraftItemModal").modal("show");
        },

        addScannedItemPrompt() {
            $("#addScannedItemModal").modal("show");
        },

        newForm() {
            if (this.grpo_id != "") {
                this.grpo_id = "";
                this.$router.push("/create-grpo");
            } else window.location.reload();
        },

        saveOrderPrompt() {
            $("#saveOrderConfirmModal").modal("show");
        },

        validateGRPOPrompt() {
            $("#saveGRPOConfirmModal").modal("show");
        },

        approveRequestPrompt() {
            $("#approveRequestConfirmModal").modal("show");
        },

        addDraftOrderItem() {
            this.draft_items.push({
                item_code: this.itemform.item_code,
                item_name: this.itemform.item_name,
                serial: this.itemform.sl,
                cgst_perc: this.itemform.item_cgst_perc,
                sgst_perc: this.itemform.item_sgst_perc,
                igst_perc: this.itemform.item_igst_perc,
                mop: this.itemform.mop,
                purchase_price: this.itemform.purchase_price,
                warehouse_code: this.itemform.item_warehouse,
                item_branch: this.itemform.item_branch,
                discount_perc: this.itemform.discount_perc,
                discount_amount: this.itemform.discount_amount,
                taxable_amount: this.itemform.item_taxable_amount,
                cgst_amount: this.itemform.item_cgst_amount,
                sgst_amount: this.itemform.item_sgst_amount,
                igst_amount: this.itemform.item_igst_amount,
                bill_price: this.itemform.bill_price,
                ship_to: this.ship_to_branch,
                tax_rate: this.itemform.item_tax_rate,
                stock: this.itemform.item_stock,
                available_stock: this.itemform.item_available_stock,
                stock_purchase_date: this.itemform.item_inward_date,
                lp: this.itemform.itemlp,
                mrp: this.itemform.item_mrp,
                item_type: this.itemform.item_type,
                hsn: this.itemform.hsn,
                brand: this.itemform.brand,
                product: this.itemform.product,
                category: this.itemform.category,
                classification: this.itemform.classification,
                o2p: this.itemform.o2p,
                ext_warranty: this.itemform.ext_warranty,
                care_pack: this.itemform.care_pack,
                division: this.itemform.division,
                incentive: this.itemform.incentive,
                loyalty: this.itemform.loyalty,
                order_quantity: this.item_quantity,
                fulfilled_quantity: this.itemform.fulfilled_quantity,
            });
            $("#addDraftItemModal").modal("hide");
        },

        addZero(i) {
            if (i < 10) {
                i = "0" + i;
            }
            return i;
        },

        saveGeneratedSerialNumbers(draft_item) {
            for (var j = 0; j < this.autogenerate_quantity; j++) {
                const d = new Date();
                var stream =
                    Math.floor(Math.random() * (999999 - 111111 + 1)) + 111111;
                var part1 = moment(this.grpo_data.created_at).format(
                    "YYYYMMDD"
                );
                var part4 = this.addZero(d.getSeconds());
                this.scanned_item = part1 + draft_item.ship_to + stream + part4;
                this.addScannedItem(draft_item);
                this.autogen_tag = "1";
                console.log(this.scanned_item);
            }
            this.autogen_tag = "";
            this.focusInput();
        },

        addScannedItem(draft_item) {
            this.focusInput();
            if (this.scanned_item != "" && this.scanned_item != null) {
                if (
                    parseFloat(this.total_scanned_items) <
                    parseInt(
                        parseInt(draft_item.order_quantity) -
                            parseInt(draft_item.fulfilled_quantity)
                    )
                ) {
                    this.serial = this.scanned_item;
                    if (
                        this.scanned_items.some(
                            (item) => item.serial === this.serial
                        )
                    ) {
                        console.log(
                            this.scanned_items.some(
                                (item) => item.serial === this.serial
                            )
                        );
                        console.log("Duplicate");
                        toast.fire({
                            title: "Duplicate Sl. No.",
                            icon: "error",
                        });
                        this.list_of_codes = "";
                        this.scanned_item = "";
                    } else {
                        this.scanned_items.push({
                            item_code: draft_item.item_code,
                            item_name: draft_item.item_name,
                            serial: this.scanned_item,
                            cgst_perc: draft_item.cgst_perc,
                            sgst_perc: draft_item.sgst_perc,
                            igst_perc: draft_item.igst_perc,
                            mop: draft_item.mop,
                            purchase_price: draft_item.purchase_price,
                            warehouse_code: draft_item.warehouse_code,
                            item_branch: draft_item.item_branch,
                            discount_perc: draft_item.discount_perc,
                            discount_amount: draft_item.discount_amount,
                            taxable_amount: draft_item.taxable_amount,
                            cgst_amount: draft_item.cgst_amount,
                            sgst_amount: draft_item.sgst_amount,
                            igst_amount: draft_item.igst_amount,
                            bill_price: draft_item.bill_price,
                            ship_to: draft_item.ship_to,
                            tax_rate: draft_item.tax_rate,
                            stock: draft_item.stock,
                            available_stock: draft_item.available_stock,
                            stock_purchase_date: draft_item.stock_purchase_date,
                            lp: draft_item.lp,
                            mrp: draft_item.mrp,
                            item_type: draft_item.item_type,
                            hsn: draft_item.hsn,
                            brand: draft_item.brand,
                            product: draft_item.product,
                            category: draft_item.category,
                            classification: draft_item.classification,
                            o2p: draft_item.o2p,
                            ext_warranty: draft_item.ext_warranty,
                            care_pack: draft_item.care_pack,
                            division: draft_item.division,
                            incentive: draft_item.incentive,
                            loyalty: draft_item.loyalty,
                            order_quantity: "1",
                            fulfilled_quantity: draft_item.fulfilled_quantity,
                            autogenerated: this.autogen_tag,
                        });
                    }
                }
            } else {
                let wordsArray = this.list_of_codes.split(" ");

                // Loop through the wordsArray and push each word into the individualWordsArray
                for (let i = 0; i < wordsArray.length; i++) {
                    // codes_buffer.push([wordsArray[i]]);
                    if (
                        parseFloat(this.total_scanned_items) <
                        parseInt(
                            parseInt(draft_item.order_quantity) -
                                parseInt(draft_item.fulfilled_quantity)
                        )
                    ) {
                        this.serial = wordsArray[i];
                        if (
                            this.scanned_items.some(
                                (item) => item.serial === this.serial
                            )
                        ) {
                            console.log(
                                this.scanned_items.some(
                                    (item) => item.serial === this.serial
                                )
                            );
                            console.log("Duplicate");
                            toast.fire({
                                title: "Duplicate Sl. No.",
                                icon: "error",
                            });
                            this.list_of_codes = "";
                            this.scanned_item = "";
                        } else {
                            this.scanned_items.push({
                                item_code: draft_item.item_code,
                                item_name: draft_item.item_name,
                                serial: wordsArray[i],
                                cgst_perc: draft_item.cgst_perc,
                                sgst_perc: draft_item.sgst_perc,
                                igst_perc: draft_item.igst_perc,
                                mop: draft_item.mop,
                                purchase_price: draft_item.purchase_price,
                                warehouse_code: draft_item.warehouse_code,
                                item_branch: draft_item.item_branch,
                                discount_perc: draft_item.discount_perc,
                                discount_amount: draft_item.discount_amount,
                                taxable_amount: draft_item.taxable_amount,
                                cgst_amount: draft_item.cgst_amount,
                                sgst_amount: draft_item.sgst_amount,
                                igst_amount: draft_item.igst_amount,
                                bill_price: draft_item.bill_price,
                                ship_to: draft_item.ship_to,
                                tax_rate: draft_item.tax_rate,
                                stock: draft_item.stock,
                                available_stock: draft_item.available_stock,
                                stock_purchase_date:
                                    draft_item.stock_purchase_date,
                                lp: draft_item.lp,
                                mrp: draft_item.mrp,
                                item_type: draft_item.item_type,
                                hsn: draft_item.hsn,
                                brand: draft_item.brand,
                                product: draft_item.product,
                                category: draft_item.category,
                                classification: draft_item.classification,
                                o2p: draft_item.o2p,
                                ext_warranty: draft_item.ext_warranty,
                                care_pack: draft_item.care_pack,
                                division: draft_item.division,
                                incentive: draft_item.incentive,
                                loyalty: draft_item.loyalty,
                                order_quantity: "1",
                                fulfilled_quantity:
                                    draft_item.fulfilled_quantity,
                                autogenerated: this.autogen_tag,
                            });
                        }
                    }
                }
            }
            this.scanned_item = "";
            this.focusInputField();
        },

        focusInput() {
            // this.$refs.scannedSerial.$el.focus();
            $("#scanItemsModal").on("shown.bs.modal", function () {
                $("#scannedSerial").focus();
            });
        },

        focusInputField() {
            // this.$refs.scannedSerial.$el.focus();
            $("#scannedSerial").focus();
        },

        deleteDraftOrderItem(index) {
            this.draft_items.splice(index, 1);
        },

        deleteScannedItem(index) {
            this.scanned_items.splice(index, 1);
        },

        searchCus() {
            this.status = "Searching...";
            axios
                .post("/api/numberSearchCus", { number: this.number })
                .then((response) => {
                    if (response.data != "") {
                        this.customer = response.data;
                        this.status = "Search Complete!";
                        this.getAddresses();
                        this.getPhoneRequests();
                        this.getNumberGifts();
                        this.getPhoneReceipts([
                            this.customer.mobile,
                            this.customer.phone,
                            this.customer.alt_mobile,
                            this.customer.alt_phone,
                        ]);
                        this.addaddress = true;
                    } else this.status = "No results. Please add customer!";
                })
                .catch(() => {
                    this.status = "Search Error!";
                });
        },

        // getTCS(url="/api/getSAPTaxCodes"){
        //     axios.post(url, {branch:this.tbranch, searchName: this.tname, category: this.tcategory})
        //         .then(response => {
        //             this.tcs = response.data.data;
        //         })
        // },

        getPurchaseAdmins(url = "/api/getPurchaseAdmins") {
            axios.post(url).then((response) => {
                this.purchase_admins = response.data;
            });
        },

        imeiSearch() {
            toast.fire({
                icon: "warning",
                title: "Searching!!!",
            });
            this.search_status = "Searching...";
            this.lshow = true;
            this.llabel = this.search_status;
            axios
                .post("/api/getSAPItemList", { params: this.params })
                .then((response) => {
                    this.search_items = response.data;
                    toast.fire({
                        icon: "success",
                        title: "Search Complete",
                    });
                    this.lshow = false;
                    this.search_status = "Search Complete!";
                    if (this.search_items.length > 0) {
                        console.log(0);
                        $("#searchitemsmodal").modal("show");
                        $("#slModal").modal("hide");
                    }
                })
                .catch((error) => {
                    toast.fire({
                        icon: "error",
                        title: "Search Failed",
                    });
                    this.lshow = false;
                    this.search_status = "Search Complete!";
                });
        },

        selectItem(item) {
            this.selected_item = item;
            this.itemform.item_code = item.ItemCode;
            this.itemform.item_name = item.ItemName;
            this.itemform.item_type = item.ItemType;
            this.itemform.item_tax_rate = item.TaxRate;
            this.itemform.branch = item.Branch;
            this.itemform.item_warehouse = item.WarehouseCode;
            this.itemform.sl = item.SerialNumber;
            this.itemform.mop = item.MOP;
            this.itemform.purchase_price = item.MOP;
            this.itemform.item_mrp = item.MRP;
            this.itemform.hsn = item.HSNEntry;
            if (typeof item.discount != null && item.discount != 0) {
                this.itemform.discount_amount =
                    item.discount.approved_discount_amount;
            } else {
                this.itemform.discount_amount = item.discount;
            }
            this.itemform.brand = item.BrandName;
            this.itemform.product = item.ProductName;
            this.itemform.category = item.Category;
            this.itemform.classification = item.Classification;
            this.itemform.o2p = item.O2Protection;
            this.itemform.ext_warranty = item.ExtendedWarrenty;
            this.itemform.care_pack = item.CarePack;
            this.itemform.itemlp = item.PurchasePrice;
            if (this.placeofsupply == 32) {
                this.itemform.item_cgst_perc = item.TaxRate / 2;
                this.itemform.item_sgst_perc = item.TaxRate / 2;
                this.itemform.item_igst_perc = 0;
            } else {
                this.itemform.item_cgst_perc = 0;
                this.itemform.item_sgst_perc = 0;
                this.itemform.item_igst_perc = item.TaxRate;
            }
            this.itemform.item_tax_rate = item.TaxRate;
            this.itemform.item_stock = item.Stock;
            this.itemform.item_type = item.ItemType;
            this.itemform.item_available_stock = item.AvailableStock;
            this.itemform.item_inward_date = item.PurchaseDate;
            this.itemform.division = item.Division;
            this.itemform.loyalty = item.Loyalty;
            this.itemform.incentive = item.Incentive;
            this.updateDiscountAmount();
            // this.$forceUpdate();
            $("#icantthinkofaname").modal("hide");
        },
        // Start here
        SAPItemCodeSearch(code) {
            toast.fire({
                icon: "warning",
                title: "Searching!!!",
            });
            this.search_status = "Searching...";
            this.lshow = true;
            this.llabel = this.search_status;
            if (this.customertype == "b2c") var phone = this.customer.mobile;
            else {
                //console.log(this.addresses.find(a => a.id == this.billing_address));
                var phone = this.customer.primary_phone;
            }
            axios
                .post("/api/SAPItemCodeSearch", {
                    code: code,
                    type: "code",
                    phone: phone,
                    branch: this.linked_branch,
                })
                .then((response) => {
                    if (response.data != 0) {
                        this.SAPItems = response.data;
                        toast.fire({
                            icon: "success",
                            title: "Search Complete",
                        });
                        $("#icantthinkofaname").modal("show");
                        $("#searchitemsmodal").modal("hide");
                        $("#itemsModal").modal("hide");
                    } else
                        toast.fire({
                            icon: "success",
                            title: "No Items",
                        });
                    this.search_status = "Search Complete!";
                    this.lshow = false;
                })
                .catch((error) => {
                    toast.fire({
                        icon: "error",
                        title: "Search Failed",
                    });
                    this.search_status = "Search Complete!";
                    this.lshow = false;
                });
        },

        itemCodeSearch(type) {
            if (this.item_code == "" || this.item_code == null) {
                toast.fire({
                    icon: "error",
                    title: "Search Failed",
                });
                return 0;
            }
            toast.fire({
                icon: "warning",
                title: "Searching!!!",
            });
            this.search_status = "Searching...";
            this.lshow = true;
            this.llabel = this.search_status;
            if (this.customertype == "b2b")
                var phone = this.vendor.primary_phone;
            else {
                //console.log(this.addresses.find(a => a.id == this.billing_address));
                var phone = this.customer.mobile;
            }
            axios
                .post("/api/SAPItemCodeSearch", {
                    code: this.item_code,
                    type: type,
                    phone: phone,
                    branch: this.linked_branch,
                })
                .then((response) => {
                    if (response.data != 0) {
                        this.SAPItems = response.data;
                        toast.fire({
                            icon: "success",
                            title: "Search Complete",
                        });
                        $("#icantthinkofaname").modal("show");
                        $("#itemCodeModal").modal("hide");
                    } else
                        toast.fire({
                            icon: "success",
                            title: "No Items",
                        });
                    this.search_status = "Search Complete!";
                    this.lshow = false;
                })
                .catch((error) => {
                    toast.fire({
                        icon: "error",
                        title: "Search Failed",
                    });
                    this.search_status = "Search Complete!";
                    this.lshow = false;
                });
        },

        clearForm() {
            window.location.reload();
            // this.$router.go()
        },

        addCustomer() {
            axios
                .post("/api/addCustomerDets", {
                    customer_id: this.customer.id,
                    customer_phone: this.customer.mobile,
                    comm_address: this.comm_address,
                    billing_address: this.billing_address,
                    id: this.job.id,
                    customer_name: this.customer.name,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Job Updated",
                        });
                        this.errors = [];
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        b2bPrompt() {
            $("#b2bsearchmodal").modal("show");
        },

        b2bSearch() {
            this.search_status = "Searching...";
            axios
                .post("/api/getSAPVendors", {
                    branch_code: this.vbranchcode,
                    vendor_code: this.vvendorcode,
                    vendor_name: this.vvendorname,
                    phone: this.vphone,
                    gst: this.vgstcode,
                })
                .then((response) => {
                    if (response.data != 0) {
                        this.vendors = response.data;
                        $("#b2bsearchmodal").modal("hide");
                        $("#vendorsmodal").modal("show");
                    } else
                        toast.fire({
                            icon: "error",
                            title: "No customers found",
                        });
                    this.search_status = "Searching Complete!";
                });
        },

        selectCustomer(cus) {
            this.vendor = cus;
            $("#vendorsmodal").modal("hide");
            this.getStatePrefix();
        },

        makeDraft() {
            this.lshow = true;
            this.llabel = "Approving Purchase Request";
            if (this.customertype == "b2b") var scustomer = this.vendor;
            else {
                //console.log(this.addresses.find(a => a.id == this.billing_address));
                this.customer.billing_address = this.addresses.find(
                    (a) => a.id == this.billing_address
                );
                this.customer.shipping_address = this.addresses.find(
                    (a) => a.id == this.comm_address
                );
                var scustomer = this.customer;
            }
            if (this.payment_items.some((el) => el.payment_mode == "Finance"))
                var paymentmode = "Finance";
            else if (
                this.payment_items.every((el) => el.payment_mode == "Cash")
            )
                var paymentmode = "Cash";
            else var paymentmode = "Credit";
            axios
                .post("/api/approvePurchaseRequest", {
                    purchase_request_id: this.pr_id,
                    apx_bill_no: this.apx_bill_no,
                    payment_status: this.payment_status,
                    draftitems: this.draft_items,
                    customer: scustomer,
                    deliverymode: this.deliverymode,
                    campaign_media: this.campaign_media,
                    customertype: this.customertype,
                    document_total: this.total_amount,
                    document_taxable_amount: this.total_taxable_amount,
                    total_cgst: this.total_cgst,
                    total_igst: this.total_igst,
                    total_sgst: this.total_sgst,
                    total_discount_amount: this.total_discount_amount,
                    total_discount_perc: this.total_discount_perc,
                    placeofsupply: this.placeofsupply,
                    buyback_item: this.buyback_items,
                    bill_type: paymentmode,
                    remarks: this.remarks,
                    to_be_approved_by: this.purchase_admin,
                    branch: this.branch,
                })
                .then((response) => {
                    $("#approveRequestConfirmModal").modal("hide");
                    toast.fire({
                        icon: "success",
                        title: "Request Approved",
                    });
                    this.llabel = "";
                    this.lshow = false;
                    this.getPurchaseRequest();
                    this.approved_purchase_request = response.data;
                    this.orders = response.data.orders;
                    $("#POGeneratedModal").modal("show");
                })
                // .then((response) => {
                //     this.lshow = false;
                //     $("#approveRequestConfirmModal").modal("hide");
                //     this.$router.push("/sale-order/" + response.data.order.id);
                //     this.llabel = "";
                // })
                .catch((errors) => {
                    this.lshow = false;
                    $("#approveRequestConfirmModal").modal("hide");
                    toast.fire({
                        icon: "error",
                        title: "Approving Purchase Request Failed!",
                    });
                    this.lshow = false;
                    $("#errormodal").modal("show");
                    this.errors = errors.response.data.errors;
                });
            this.lshow = false;
        },

        addFile() {
            this.files = [];
            let uploadedFiles = this.$refs.file.files;
            /*
  					Adds the uploaded file to the files array
					*/
            for (var i = 0; i < uploadedFiles.length; i++) {
                let temp = {
                    file: uploadedFiles[i],
                    url: URL.createObjectURL(uploadedFiles[i]),
                };
                this.files.push(temp);
            }
        },

        saveDraft() {
            this.lshow = true;
            this.llabel = "Creating GRPO draft";
            toast.fire({
                icon: "success",
                title: "Drafting GRPO...",
            });
            if (this.customertype == "b2b") var scustomer = this.vendor;
            else {
                //console.log(this.addresses.find(a => a.id == this.billing_address));
                this.customer.billing_address = this.addresses.find(
                    (a) => a.id == this.billing_address
                );
                this.customer.shipping_address = this.addresses.find(
                    (a) => a.id == this.comm_address
                );
                var scustomer = this.customer;
            }
            if (this.payment_items.some((el) => el.payment_mode === "Finance"))
                var paymentmode = "Finance";
            else if (
                this.payment_items.every((el) => el.payment_mode === "Cash")
            )
                var paymentmode = "Cash";
            else var paymentmode = "Credit";
            axios
                .post("/api/saveGRPO", {
                    grpo_id: this.grpo_id,
                    purchase_request_id: this.pr_id,
                    purchase_order_id: this.po_id,
                    apx_bill_no: this.apx_bill_no,
                    payment_status: this.payment_status,
                    draftitems: this.draft_items,
                    paymentitem: this.payment_items,
                    customer: scustomer,
                    deliverymode: this.deliverymode,
                    campaign_media: this.campaign_media,
                    customertype: this.customertype,
                    document_total: this.total_amount,
                    document_taxable_amount: this.total_taxable_amount,
                    total_cgst: this.total_cgst,
                    total_igst: this.total_igst,
                    total_sgst: this.total_sgst,
                    total_discount_amount: this.total_discount_amount,
                    total_discount_perc: this.total_discount_perc,
                    placeofsupply: this.placeofsupply,
                    bill_type: paymentmode,
                    remarks: this.remarks,
                    buyback_items: this.buyback_items,
                    purchase_request_status: this.purchase_request_status,
                    turnaway_reason: this.turnaway_reason,
                    to_be_approved_by: this.purchase_admin,
                    branch: this.branch,
                })
                .then((response) => {
                    this.grpo_data = response.data.order;
                    toast.fire({
                        title: "Saved!",
                        icon: "success",
                    });
                    this.grpo_id = this.grpo_data.id;
                    this.llabel = "";
                    this.lshow = false;
                    $("#saveOrderConfirmModal").modal("hide");
                })
                .catch((errors) => {
                    this.lshow = false;
                    toast.fire({
                        icon: "error",
                        title: "GRPO Drafting Failed!",
                    });
                    $("#errormodal").modal("show");
                    this.errors = errors.response.data.errors;
                });
            this.lshow = false;
        },

        saveItems() {
            this.lshow = true;
            this.llabel = "Saving GRPO Items";
            toast.fire({
                icon: "success",
                title: "Saving Items to GRPO...",
            });
            axios
                .post("/api/saveGRPOItems", {
                    grpo_id: this.grpo_id,
                    purchase_request_id: this.pr_id,
                    purchase_order_id: this.po_id,
                    scanneditems: this.scanned_items,
                })
                .then((response) => {
                    this.saved_data = response.data.data;
                    toast.fire({
                        title: "Saved!",
                        icon: "success",
                    });
                    this.llabel = "";
                    this.lshow = false;
                    this.scanned_items = [];
                    $("#saveOrderConfirmModal").modal("hide");
                })
                .catch((errors) => {
                    this.lshow = false;
                    toast.fire({
                        icon: "error",
                        title: "Saving Items Failed!",
                    });
                    $("#errormodal").modal("show");
                    this.errors = errors.response.data.errors;
                });
            this.lshow = false;
            this.scan_mode = true;
        },

        validateGRPO() {
            this.returned_errors = [];
            this.errors = [];
            this.lshow = true;
            this.llabel = "Saving GRPO to ERP";
            toast.fire({
                icon: "success",
                title: "Saving Items to ERP...",
            });
            var formData = new FormData();
            formData.set("grpo_id", this.grpo_id);
            formData.set("purchase_request_id", this.pr_id);
            formData.set("purchase_order_id", this.po_id);
            formData.set("purchase_invoice_image", this.purchase_invoice_image);
            axios({
                method: "post",
                url: "/api/validateGRPO",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then((response) => {
                    this.saved_data = response.data.data;
                    if (this.saved_data != []) {
                        toast.fire({
                            title: "Saved!",
                            icon: "success",
                        });
                        this.llabel = "";
                        this.lshow = false;
                        this.scanned_items = [];
                        this.getGRPO();
                        $("#saveGRPOConfirmModal").modal("hide");
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Validating GRPO Failed!",
                        });
                        $("#saveGRPOConfirmModal").modal("hide");
                        $("#errormodal").modal("show");
                        this.errors =
                            response.data.doc_data.response.ResponseMessage;
                        this.returned_errors = JSON.stringify(
                            JSON.parse(
                                response.data.doc_data.response.ResponseMessage
                            ),
                            null,
                            2
                        );
                        console.log(this.errors);
                    }
                })
                .catch((errors) => {
                    this.lshow = false;
                    toast.fire({
                        icon: "error",
                        title: "Saving GRPO Failed!",
                    });
                    $("#errormodal").modal("show");
                    this.errors = errors.response.data.errors;
                });
            this.lshow = false;
        },

        addb2bPrompt() {
            $("#b2bprimarymodal").modal("show");
        },

        b2bNextStep() {
            if (Object.values(this.b2bform).some((x) => x === null || x === ""))
                toast.fire({
                    icon: "error",
                    title: "All fields must be filled",
                });
            else {
                $("#b2bprimarymodal").modal("hide");
                $("#b2baddressmodal").modal("show");
            }
        },

        b2bPushAddress() {
            if (
                Object.values(this.b2baddressform).some(
                    (x) => x === null || x === ""
                )
            )
                toast.fire({
                    icon: "error",
                    title: "All fields must be filled",
                });
            else {
                this.submitvendor = true;
                this.newb2bAddresses.push(this.b2baddressform);
                this.b2baddressform = {
                    AddressType: "",
                    Address: "",
                    Building: "",
                    Street: "",
                    StreetNo: "",
                    Block: "",
                    City: "",
                    District: "",
                    ZipCode: "",
                    State: "",
                    Country: "",
                    GSTNo: "",
                };
            }
        },

        cleanScannedItemsArray() {
            this.scanned_items = [];
            this.list_of_codes = "";
            this.scanned_item = "";
            this.focusInputField();
        },

        createb2bUser() {
            axios
                .post("/api/createB2bCustomer", {
                    primary: this.b2bform,
                    addresses: this.newb2bAddresses,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "B2B Customer Created",
                    });
                    this.errors = [];
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getCreditLimit() {
            if (this.customertype == "b2c") {
                var phone = this.customer.mobile;
            } else {
                var phone = this.vendor.primary_phone;
            }
            axios
                .post("/api/getCreditLimit", { phone: phone })
                .then((response) => {
                    this.credit_limit = response.data;
                });
        },

        viewPurchaseInvoice() {
            // let route = this.$router.resolve(this.request_data.purchase_invoice_url);
            // // let route = this.$router.resolve('/link/to/page'); // This also works.
            // window.open(route.href, '_blank');
            $("#purchaseinvoicemodal").modal("show");
        },

        imageRotation() {
            this.deg += 90;
        },
    },
};
</script>
<style>
.header {
    position: sticky;
    top: 0;
}
</style>
